import React, { useContext, useState, useEffect } from 'react';
import Signup from '../../composed/signup/Signup';

import './CheckZipcode-Page.scss';
import GoogleMap from '../../composed/googlemap/GoogleMap';
import OtpVerify from '../../composed/otpverify/OtpVerify';
import CheckZipcode from '../../composed/checkzipcode/CheckZipcode';
import { isMobile, isDesktop, isIpad } from '../../utils/ScreenSizeHelper';
import NoServicePage from '../no-service-page/NoService-Page';
import { FIRST_TIME_CHECKER_PNG } from '../../utils/imageIconsConstants';
import { GlobalStateDataContext } from '../../context-api/data-provider/GlobalStateDataProvider';
import { publicIp, publicIpv4, publicIpv6 } from 'public-ip';
import CongratsStep from '../../composed/congratsstep/CongratsStep';
import SideContentOne from '../../composed/sidecontent/SideContent-One';
import HowItWorks from './HowItWork';
import { BorderBottom } from '@mui/icons-material';
import GOAL from '../../utils/assets/svg/Goals.svg';

const CheckZipcodePage = () => {
  const { showCongrat, showSignup } = useContext(GlobalStateDataContext);

  if (isMobile) {
    return <NoServicePage />;
  }

  const headerRow = {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    width: '900px',
    borderBottom: '1px solid #4E56C0',
    marginBottom: '20px',
  };

  const titleColumn = {
    flex: 1,
    marginLeft: '30px',
  };
  const heading = {
    margin: 0,
    color: 'rgb(63, 63, 110)',
    fontFamily: 'Inter Regular',
    fontSize: 24,
    // fontWeight: 600,
  };

  const subtitle = {
    marginTop: 8,
    fontFamily: 'Inter Regular',
    color: '#4E56C0',
    lineHeight: 1.4,
  };

  return (
    <div className='signup-desktop-container'>
      {showCongrat === false && (
        <div style={headerRow}>
          <img width='25%' src={GOAL} alt=''></img>
          <div style={titleColumn}>
            <h1 style={heading}>Empowering Local Businesses</h1>
            <p style={subtitle}>
              Other delivery apps weren’t built for your profitability or to help you attract more
              customers. We help you earn more on every order, reach new customers, and stay on top
              of the app with features designed to boost your visibility and sales.{' '}
              <div
                style={{ fontFamily: 'Roboto Italic', color: 'rgb(63, 63, 110)', marginTop: '5px' }}
              >
                Because your growth is our growth.
              </div>
            </p>
          </div>
        </div>
      )}

      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          width: 'auto',
          marginTop: '10px',
          marginBottom: '100px',
        }}
      >
        <div style={{ marginRight: '10px' }}>
          <SideContentOne />
        </div>

        <div style={{ marginLeft: '15px' }}>
          {showCongrat === false && <CheckZipcode />}
          {showCongrat && <CongratsStep />}
        </div>
      </div>
    </div>
  );
};

export default CheckZipcodePage;
